import { render } from "./ReferenceCardActions.vue?vue&type=template&id=76752dac&scoped=true"
import script from "./ReferenceCardActions.vue?vue&type=script&lang=js"
export * from "./ReferenceCardActions.vue?vue&type=script&lang=js"

import "./ReferenceCardActions.vue?vue&type=style&index=0&id=76752dac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76752dac"]])

export default __exports__